import React from "react";
import { Link, useNavigate } from "react-router-dom";

function Privacy() {
  const navigate = useNavigate();

  return (
    <div className="bg-gradient-to-b from-[#000000] to-[#1a1a1a] min-h-screen">
      <head>
        <link rel="icon" href="/img/logo_trans.png" />
        <title>Emotionly - Privacy Policy</title>
        <meta
          name="description"
          content="Discover a new way to connect and improve your emotional well-being with our innovative app. Emotionly is a personal emotional tracker that helps you gain insight into your feelings, patterns, and triggers. With daily tracking and analysis, you can develop self-awareness, enhance your emotional intelligence, and manage your mental health effectively. Our app is perfect for anyone looking to build deeper connections based on emotional compatibility, track their moods and emotions, and enhance their overall well-being. Download Emotionly today and start exploring the power of emotional tracking for a happier, healthier you!"
        />
        <meta property="og:title" content="Emotionly - Privacy Policy" />
        <meta
          property="og:description"
          content="Discover a new way to connect and improve your emotional well-being with our innovative app. Emotionly is a personal emotional tracker that helps you gain insight into your feelings, patterns, and triggers. With daily tracking and analysis, you can develop self-awareness, enhance your emotional intelligence, and manage your mental health effectively. Our app is perfect for anyone looking to build deeper connections based on emotional compatibility, track their moods and emotions, and enhance their overall well-being. Download Emotionly today and start exploring the power of emotional tracking for a happier, healthier you!"
        />
        <meta property="og:url" content="https://emotionly.app/" />
        <meta property="og:type" content="website" />
      </head>
      <main className="flex min-h-screen min-w-full flex-col items-center justify-between p-4">
        <div className="z-10 w-full items-center justify-between font-mono text-sm lg:flex">
          <div className="relative py-3 w-full sm:mx-auto">
            <div
              className="px-2 sm:px-10 py-4 w-full min-h-[94vh] flex flex-col bg-white shadow-2xl rounded-3xl bg-clip-padding bg-opacity-10 border border-gray-100"
              style={{ backdropFilter: "blur(60px)" }}
            >
              <Link to={"/"}>
                <img
                  className="  "
                  src="/img/logo_trans.png"
                  alt="Picture of the author"
                  width={60}
                  height={60}
                />
              </Link>

              <h1 className="text-white text-center font-roboto font-bold text-2xl sm:text-3xl ">
                Privacy Policy
              </h1>

              <div className="mt-3 px-3 sm:px-10 text-white font-roboto mb-5 page-content">
                <p class="c4" data-v-1017d85d="">
                  <span class="c3" data-v-1017d85d="">
                    We are strongly committed to letting you know how we will
                    collect and use your personal information. &nbsp;
                  </span>
                  <span class="c3" data-v-1017d85d="">
                    The policies below are applicable to the “Emotionly” app and
                    its related companies; the “Emotionly” website located at
                    www.emotionly.app; all e-mail newsletters published or
                    distributed by Emotionly; and all other interactive features
                    and communications provided by Emotionly, however accessed
                    and/or used, that are operated by us, made available by us,
                    or produced and maintained by Emotionly (collectively
                    Emotionly or “we”, “us”, or “our”) (“App”).{" "}
                  </span>
                  <span class="c0" data-v-1017d85d="">
                    We have established this privacy policy (“Privacy Policy”)
                    to let you know the kinds of personal information we may
                    gather during your use of this App, why we gather your
                    information, what we use your personal information for, when
                    we might disclose your personal information, and how you can
                    manage your personal information. &nbsp;
                  </span>
                </p>

                <br />
                <p class="c4" data-v-1017d85d="">
                  <span class="c11" data-v-1017d85d="">
                    Please be advised that the practices described in this
                    Privacy Policy apply only to information gathered online
                    through our App. It does not apply to information that you
                    may submit to us offline or by companies or organizations to
                    which we may link or who may link to us.{" "}
                  </span>
                </p>

                <br />

                <p class="c4" data-v-1017d85d="">
                  <span class="c11" data-v-1017d85d="">
                    By using our App, you are accepting the practices described
                    in our Privacy Policy. &nbsp;If you do not agree to the
                    terms of this Privacy Policy, please do not use the App.
                    &nbsp;We reserve the right to modify or amend the terms of
                    our Privacy Policy from time to time without notice. Your
                    continued use of our App following the posting of changes to
                    these terms will mean you accept those changes. &nbsp;If we
                    intend to apply the modifications or amendments to this
                    Privacy Policy retroactively or to personal information
                    already in our possession, we will provide you with notice
                    of the modifications or amendments.
                  </span>
                </p>

                <br />

                <ol start={"1"}>
                  <li className=" text-xl font-semibold ">
                    1. What Information is Collected & Stored
                  </li>

                  <p class="c4" data-v-1017d85d="">
                    <span class="c0" data-v-1017d85d="">
                      We recognize that your use of the App may involve
                      sensitive and highly personal feelings. &nbsp;We have
                      designed the App to minimize the personal information that
                      is collected from you.
                    </span>
                  </p>
                  <br />

                  <p class="c4" data-v-1017d85d="">
                    <span class="c0" data-v-1017d85d="">
                      We collect two basic types of information from you in
                      conjunction with your use of the App, personal information
                      and non-personal information. &nbsp;Personal information
                      is information that you supply to us, as described more
                      fully below. &nbsp;Non-personal information is information
                      that does not personally identify you. It is diagnostic
                      data that we aggregate, such as which emotions are most
                      frequently chose, which videos are watched and for how
                      long, and other data about the performance of the App.
                    </span>
                  </p>

                  <br />
                  <p>
                    Emotionly uses the information collected in the App for
                    providing high quality Services and suggesting and
                    recommending people based on emotions and thoughts which are
                    best suited for the User, processing payments, assessing
                    User preference and other aspects. All information collected
                    on the App could be used to resolve disputes, troubleshoot
                    problems, collect receivables, surveys on User interest in
                    the App, inform User about promotions and offers, detecting
                    fraud and other criminal activity, to enforce Terms and
                    Conditions and other related policies.
                  </p>

                  <br />
                  <li className=" font-semibold ">A. Personal Information</li>

                  <p className="c4 py-1" data-v-1017d85d="">
                    <span class="c3" data-v-1017d85d="">
                      As a general matter, you can use and browse the App
                      without submitting your personal information to us.
                      &nbsp;However, there are a few circumstances in which you
                      may supply us with your personal information. &nbsp;The
                      following lists the ways in which we may collect your{" "}
                    </span>
                    <span class="c3" data-v-1017d85d="">
                      personal information
                    </span>
                    <span class="c0" data-v-1017d85d="">
                      .
                    </span>
                  </p>

                  <ul className=" ml-8 " data-v-1017d85d="">
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                    >
                      <span class="c0" data-v-1017d85d="">
                        Registration for an account on the App
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                    >
                      <span class="c0" data-v-1017d85d="">
                        Profile information that You provide for Your user
                        profile{" "}
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                    >
                      <span class="c3" data-v-1017d85d="">
                        Your member ID when required to access the Emotionly
                        service
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                    >
                      <span class="c3" data-v-1017d85d="">
                        {" "}
                        Journals & information shared through the app
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                    >
                      <span class="c0" data-v-1017d85d="">
                        Information shared to receive alerts or other
                        information via email, text or notifications.
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                    >
                      <span class="c0" data-v-1017d85d="">
                        App related communications, e.g. customer support
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                    >
                      <span class="c0" data-v-1017d85d="">
                        Submission of content or other data and information on
                        any part of the App that permits it
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                    >
                      <span class="c0" data-v-1017d85d="">
                        Any other place on the App where you knowingly volunteer
                        personal information
                      </span>
                    </li>
                  </ul>

                  <br />

                  <p>
                    Any personal information colledted through the App or while
                    using the service will not be used for marketing,
                    advertising or any targeted promotions. It will also not be
                    shared with any third party for promotion or marketing
                  </p>

                  <br />

                  <li className=" font-semibold ">
                    B. Non-Personal Information
                  </li>

                  <p class="c4" data-v-1017d85d="">
                    <span class="c3" data-v-1017d85d="">
                      In addition, when you interact with the App, we may
                      collect certain information that does not identify you
                      individually and our servers may automatically keep an
                      activity log of your use of our App (“
                    </span>
                    <span class="c3" data-v-1017d85d="">
                      Non-Personal Information
                    </span>
                    <span class="c0" data-v-1017d85d="">
                      ”). Generally, we collect and store the following
                      categories of Non-Personal Information:
                    </span>
                  </p>

                  <ul
                    className="mt-2 ml-8 c22 lst-kix_list_3-0 start"
                    data-v-1017d85d=""
                  >
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        Non-identifiable demographic data such as age, gender,
                        and the name of emotions as part of collecting personal
                        information
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        Device information about your computer, browser, mobile
                        device, or other device that you use to access the App.
                        &nbsp;This information may include IP address,
                        geolocation information, unique device identifiers,
                        browser type, browser language, and other transactional
                        information.
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        Analytics and usage information about your use of the
                        App. &nbsp;
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        Additional “traffic data” and log files such as time of
                        access, date of access, software crash reports, session
                        identification number, access times, and referring App
                        addresses.
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        Other information regarding your use of the App.
                      </span>
                    </li>
                  </ul>

                  <br />

                  <li className=" font-semibold ">C. System Logs</li>

                  <p>
                    Emotionly doesnt use any log information other than
                    monitoring system logs in realtion to crash of the app and
                    monitoring its performance. Emotionly uses Firebase
                    Crashanalytics to monitor the performance of the app and to
                    monitor the crash of the app. The crash analytics data is
                    not shared with any third party and is only used to improve
                    the performance of the app.
                  </p>

                  <br />

                  <li className=" font-semibold ">D. Cookies</li>

                  <p>
                    Like many websites and mobile applications, we use
                    “cookies”, which are small text files that are stored on
                    your computer or equipment when you visit certain online
                    pages that record your preferences and actions. We may also
                    use cookies to monitor traffic, improve the App and make it
                    easier and/or relevant for your use. Like many sites, we use
                    cookies, web beacons and similar technologies to record your
                    preferences, and track the use of our properties. We may
                    also use these technologies to monitor traffic, improve the
                    App and make it easier and/or relevant for your use. If you
                    delete your cookies or if you set your browser or device to
                    decline these technologies, some features of the App may not
                    work or may not work as designed.
                  </p>
                  <br />
                  <p>
                    We use both “session” cookies and “persistent” cookies. We
                    do not use flash cookies, web storage, web beacons or other
                    technology that tracks your browsing history across multiple
                    websites.
                  </p>
                  <p>
                    Cookies are not linked to any Personally Identifiable
                    Information and Users who refuse cookies assume all
                    responsibility for any resulting loss of functionality.
                  </p>

                  <br />
                  <li className=" font-semibold ">E. Analytics</li>

                  <p>
                    We also use various analytics services on our App to help us
                    analyze how users interact with and use the App, compile
                    reports on the App’s activity, and provide other services
                    related to App activity and usage. These analytics services
                    use technologies that may collect various information from
                    you such as your IP address, time of visit, whether you are
                    a return visitor, and any referring site. The App does not
                    use these analytics services to gather information that
                    personally identifies you.
                  </p>

                  <p>
                    We use Firebase Analytics to track and monitor the
                    performance of the app, usage details and associated
                    information to improve the service.
                  </p>

                  <br />

                  <li className=" text-xl font-semibold ">
                    2. How Data is Used?
                  </li>
                  <p>
                    We use the information we learn from you to help us
                    personalize and continually improve your experience on the
                    App. We may use your Personal and Non-Personal Information
                    in the following ways:
                  </p>

                  <ul
                    className=" mt-2 ml-8 c22 lst-kix_list_4-0 start"
                    data-v-1017d85d=""
                  >
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To provide the Organization’s products and services
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To communicate with you about your account or
                        transactions with us or other users of the App
                        (including service related announcements) and send you
                        information about features and enhancements on our App{" "}
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c8 c5 c9 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To upload your content to our App as you request
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c8 c5 c9 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To permit you to update, edit, and manage your content
                        on our App{" "}
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To communicate with you about changes to our policies
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To personalize content and experiences on our App,
                        including providing you reports, recommendations and
                        feedback based on your preferences
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To analyze, optimize or improve our products, services
                        and operations
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To automatically update the App on your device
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To prevent activities that may violate our policies
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To anonymously use the information from User experiences
                        to continue our research into successful relationships.
                        This research, conducted by psychologists and behavior
                        research scientists on the panel of Emotionly may be
                        published in academic journals. All responses are kept
                        anonymous, and not published.
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        To perform background checks and ensure the sanctity of
                        the platform and service
                      </span>
                    </li>
                  </ul>

                  <br />

                  <li className=" text-xl font-semibold ">
                    3. Disclosure of Information
                  </li>

                  <p>
                    For providing the Services Emotionly will disclose User
                    profile information and verification results to people
                    having same emotions and thoughts in the App. Photos and
                    other profile information posted by User will be available
                    for viewing. Emotionly could make features available
                    enabling User matches to share User profile information,
                    including photos, with members of their social network(s).
                    User contact information is never shared with anyone on the
                    platform
                  </p>

                  <p>
                    Emotionly would use the information for conducting
                    appropriate background checks either itself or through hird
                    party expert service provider or their associates do not
                    warrant accuracy, validity or completeness of the content of
                    the Verification checks.
                  </p>

                  <br />

                  <p>
                    Disclosure By Law. User acknowledges and agrees that
                    Emotionly may disclose information User provides if required
                    to do so by law, at the request of a third party, or if in
                    Emotionly"s sole discretion, believe that disclosure is
                    reasonable to
                  </p>

                  <ul
                    className=" mt-2 ml-8 c22 lst-kix_list_4-0 start"
                    data-v-1017d85d=""
                  >
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        Comply with the law or legal process served on Emotionly
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        Protect and defend the rights or property of Emotionly
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        Act in urgent circumstances to protect the personal
                        safety of users of the App or the public
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        protect someone"s health or safety, such as when harm or
                        violence against any person is threatened; or
                      </span>
                    </li>
                    <li
                      style={{
                        listStyleType: "disc",
                      }}
                      class="c4 c5 li-bullet-0"
                      data-v-1017d85d=""
                    >
                      <span class="c0" data-v-1017d85d="">
                        for investigative purposes.
                      </span>
                    </li>
                  </ul>

                  <br />

                  <li className=" text-xl font-semibold ">
                    4. Information Sharing
                  </li>
                  <p class="c4" data-v-1017d85d="">
                    <span class="c3" data-v-1017d85d="">
                      Except as disclosed in this Privacy Policy, we do not
                      disclose information about your Personal Information.
                      &nbsp;
                    </span>
                  </p>

                  <br />

                  <li className=" text-xl font-semibold ">
                    5. What Steps Are Taken To Keep Personal Information Secure?
                  </li>
                  <p class="c32" data-v-1017d85d="">
                    <span class="c0" data-v-1017d85d="">
                      Your information collected through the App will be stored
                      and processed in the cloud servers situated in United
                      States or India. We exercise care in providing secure
                      transmission of your information from your device to our
                      servers. &nbsp;Personal Information collected by our App
                      are stored in secure operating environments that are not
                      available to the public. &nbsp;Our security procedures
                      mean that we may occasionally request proof of identity
                      before we disclose your Personal Information to you.
                      &nbsp;Please understand, however, that while we try our
                      best to safeguard your Personal Information once we
                      receive it, no transmission of data over the Internet or
                      any other public network can be guaranteed to be 100%
                      secure. &nbsp;
                    </span>
                  </p>

                  <br />

                  <li className=" text-xl font-semibold ">
                    6. How Long Do We Keep Your Information?
                  </li>
                  <p class="c9 c39" data-v-1017d85d="">
                    <span class="c1" data-v-1017d85d="">
                      Following termination or deactivation of your account, we
                      will delete your personal information, provided that
                      Organization, or its service providers may retain
                      information (including your profile information) for a
                      commercially reasonable time for backup, archival, and/or
                      audit purposes. If you have any questions about
                      termination or deactivation of your account, please
                      contact us directly at{" "}
                    </span>
                    <span class="c20 c3" data-v-1017d85d="">
                      privacy@emotionly.
                    </span>
                    <span class="c3 c20" data-v-1017d85d="">
                      app
                    </span>
                    <span class="c3" data-v-1017d85d="">
                      .{" "}
                    </span>
                  </p>

                  <br />

                  <li className=" text-xl font-semibold ">7. Governing Law</li>
                  <p class="c4" data-v-1017d85d="">
                    <span class="c0" data-v-1017d85d="">
                      We attempt to protect the Personal Information of all
                      users of our App and we attempt to comply with local data
                      protection and consumer rights laws to the extent they may
                      apply to the Organization’s services, but our App is
                      located from India and our policies are directed at
                      compliance with those laws. &nbsp;If you are uncertain
                      whether this privacy policy conflicts with the applicable
                      local privacy laws where you are located, you should
                      consider the applicable laws and provisions of India.
                      &nbsp;
                    </span>
                  </p>

                  <br />

                  <li className=" text-xl font-semibold ">8. Assignment</li>
                  <p class="c4" data-v-1017d85d="">
                    <span class="c0" data-v-1017d85d="">
                      We may change our ownership or corporate organization
                      while providing the App. &nbsp;We may also sell certain
                      assets associated with the App. &nbsp;As a result, please
                      be aware that in such event we may transfer some or all of
                      your information to an organization acquiring all or part
                      of our assets or to another organization with which we
                      have merged. &nbsp;Under such circumstances we would, to
                      the extent possible, require the acquiring party to follow
                      the practices described in this Privacy Policy, as it may
                      be amended from time to time. &nbsp;Nevertheless, we
                      cannot promise that an acquiring entity or the merged
                      entity will have the same privacy practices or treat your
                      information the same as described in this Privacy Policy.
                    </span>
                  </p>

                  <br />

                  <li className=" text-xl font-semibold ">
                    9. Opt-out Provisions
                  </li>
                  <p>
                    User has the right to opt-in or opt-out of any
                    marketing/promotional/newsletter mailings. Upon opting out,
                    provisions of this Terms and Conditions and the related
                    policies will become applicable. However, Emotionly reserves
                    the right to send service related communication without
                    offering User the facility to opt-out. User can update your
                    account settings and information at any time. At User"s
                    request, Emotionly can cancel User registration and
                    remove/block personally identifiable information from it"s
                    database. However, this information may remain in archives
                    even after deletion or termination of User account as
                    required by law and the handling of the same is in
                    accordance with the provisions of the applicable law and as
                    intimated by the government agency from time to time. You
                    can contact our support team at contact@emotionly.app
                    through your registered email address with a request to
                    delete your data from our records.
                  </p>

                  <br />

                  <li className=" text-xl font-semibold ">
                    10. Security Practices
                  </li>
                  <p>
                    Emotionly follows stringent security techniques and
                    requirements for handling sensitive and personal
                    information. These techniques and requirements are fully
                    compliant with the guidelines set forth under law. Emotionly
                    servers are accessible only to authorized personnel. User
                    information logged under the Terms and Conditions is shared
                    with respective personnel only on need to know basis and/ or
                    for the purpose of completing a transaction and/ or to
                    providing Services. All representatives handling information
                    under these provisions are under contractual confidentiality
                    obligation with Emotionly. While, Emotionly takes every step
                    to safeguard the confidentiality of User personal
                    information, by using the Site, User agrees and confirms
                    that Emotionly is not liable for any disclosure due to
                    errors in transmission or unauthorized acts of third
                    parties.
                  </p>
                </ol>
              </div>

              {/* Footer Section */}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Privacy;
